import { Modal } from "bootstrap";
import e from 'lodash.escape';
import _t from '../modules/translations';

const qs = (selector) => document.querySelector(selector);
const checkedValue = (name) => qs(`input[name="${name}"]:checked`)?.value ?? '';

const dnsRecords = () => {
    const $userDnsTable = qs('#userDnsTable');
    const $dnsDeleteModal = qs('#dnsDeleteModal');
    const allowedDmarcRecords = JSON.parse($userDnsTable.dataset.alloweddmarcrecords);
    const allowedSPFRecordTypes = JSON.parse($userDnsTable.dataset.allowedspfrecordtypes);
    let $editableRow = '';
    let isRemovingEditForm = false;

    const spfQualifiers = {
        '': 'Default (Pass)',
        '+': 'Pass',
        '~': 'Soft fail',
        '-': 'Hard fail',
        '?': 'Neutral'
    };

    const editableForm = (values = {}) => {
        const dnsType = window.euAdminConfig.dns || [];
        let html = `<form id="content-edit-form" class="content-edit-form" action="${(values.saveUrl)}" method="post">`
        + `             <input type="hidden" name="_token" value="${(values.token)}">`;
        if (values.id) {
            html += '   <input type="hidden" name="_method" value="PUT">';
        }
        html += '       <div class="content-row content-edit-row">'
        + '             <div class="content-edit-icon"><i class="fa fa-times" aria-hidden="true"></i></div>'
        + '             <div class="content-column content-column-wide">'
        + '                 <div class="eu-field">'
        + `                     <input type="text" name="name" class="form-control" id="name" value="${(values.hostname ? e(values.hostname) : '')}" placeholder="${_t('Hostname')}" autofocus/>`
        + '                 </div>'
        + '             </div>'
        + '             <div class="content-column content-column-wide">'
        + '                 <select class="form-select" name="type" id="status">'
        dnsType.forEach((item) => {
            if (values.type === item) {
                html += `<option value="${item}" selected>${item}</option>`;
            } else {
                html += `<option value="${item}">${item}</option>`;
            }
        });
        html += '          </select>'
        + '             </div>'
        + '             <div class="content-column content-column-wide">'
        + '                 <div class="eu-field">';

        // The SPF/DMARC editor is built as a top-level element and appended to <body> instead of
        // nesting it inside the row: a Bootstrap modal nested inside other positioned/transitioned
        // ancestors gets its backdrop stacking wrong and flickers on hover/mousemove, see
        // https://github.com/twbs/bootstrap/issues/41495
        let modalHtml = '';

        const allowedDmarcRecordPolicyTypes = ['none', 'quarantine', 'reject'];
        const allowedDmarcRecordSubdomainPolicyTypes = ['', 'none', 'quarantine', 'reject'];
        const allowedDmarcRecordNpPolicyTypes = ['', 'none', 'quarantine', 'reject'];
        const allowedDmarcRecordAdkimTypes = {
            '': _t('Not set'),
            'r': _t('r (relaxed)'),
            's': _t('s (strict)')
        };
        const allowedDmarcRecordAspfTypes = {
            '': _t('Not set'),
            'r': _t('r (relaxed)'),
            's': _t('s (strict)')
        };

        //make object with key value pairs for dmarc record string
        const dmarcRecordData = values.content?.trim(';').split(';').map((item) => item.trim().split('=')).reduce((acc, item) => {
            acc[item[0]] = item[1];
            return acc;
        });

        const currentDmarcRecordPolicyType = dmarcRecordData?.['p'] ?? 'none';
        const currentDmarcRecordSubdomainPolicyType = dmarcRecordData?.['sp'] ?? '';

        let currentDmarcRecordNpPolicyType = '';
        if (dmarcRecordData && dmarcRecordData.np) {
            currentDmarcRecordNpPolicyType = dmarcRecordData.np;
        }

        let currentDmarcRecordRUA = '';
        if (dmarcRecordData && dmarcRecordData.rua) {
            currentDmarcRecordRUA = dmarcRecordData.rua.replace('mailto:', '');
        }

        let currentDmarcRecordRUF = '';
        if (dmarcRecordData && dmarcRecordData.ruf) {
            currentDmarcRecordRUF = dmarcRecordData.ruf.replace('mailto:', '');
        }

        let currentDmarcRecordAdkim = '';
        if (dmarcRecordData && dmarcRecordData.adkim) {
            currentDmarcRecordAdkim = dmarcRecordData.adkim;
        }

        let currentDmarcRecordAspf = '';
        if (dmarcRecordData && dmarcRecordData.aspf) {
            currentDmarcRecordAspf = dmarcRecordData.aspf;
        }

        if (values.content?.includes('v=DMARC')) {
            modalHtml = `<div id="dmarcModal" class="modal" tabindex="-1">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">${_t('DMARC record editor')}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="${_t('Close')}"></button>
                          </div>
                          <div class="modal-body">

                           <div class="mt-3 mb-3">
                                 <h5>${_t('Raw DNS record value')}:</h5>
                                 <code class="text-wrap ms-2" id="raw_dmarc_value">${e(values.content)}</code>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                    <div class="form-label">${_t('Policy')}</div>
            `;
            allowedDmarcRecordPolicyTypes.forEach((item, index) => {
                const checkedHtml = currentDmarcRecordPolicyType === item ? `checked` : ``;
                modalHtml += `<div class="form-check form-check-inline">
                                        <input form="dmarc_form" class="form-check-input" type="radio" name="p" id="p_${index}" value='${e(item)}' ${checkedHtml}>
                                        <label class="form-check-label" for="p_${index}">${e(item)}</label>
                                      </div>`;
            });
            modalHtml += `
                                </div>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                    <div class="form-label">${_t('Subdomain policy (sp tag, optional)')}</div>
            `;
            allowedDmarcRecordSubdomainPolicyTypes.forEach((item, index) => {
                const checkedHtml = currentDmarcRecordSubdomainPolicyType === item ? `checked` : ``;
                modalHtml += `<div class="form-check form-check-inline">
                                        <input form="dmarc_form" class="form-check-input" type="radio" name="sp" id="sp_${index}" value='${e(item)}' ${checkedHtml}>
                                        <label class="form-check-label" for="sp_${index}">${item === '' ? _t('Not set') : e(item)}</label>
                                      </div>`;
            });
            modalHtml += `
                                </div>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                    <div class="form-label">${_t('Non-existent subdomain policy (np tag, optional)')}</div>
            `;
            allowedDmarcRecordNpPolicyTypes.forEach((item, index) => {
                const checkedHtml = currentDmarcRecordNpPolicyType === item ? `checked` : ``;
                modalHtml += `<div class="form-check form-check-inline">
                                        <input form="dmarc_form" class="form-check-input" type="radio" name="np" id="np_${index}" value='${e(item)}' ${checkedHtml}>
                                        <label class="form-check-label" for="np_${index}">${item === '' ? _t('Not set') : e(item)}</label>
                                      </div>`;
            });
            modalHtml += `
                                </div>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                    <div class="form-label">${_t('Alignment mode for the DKIM protocol (adkim tag)')}</div>
            `;
            Object.entries(allowedDmarcRecordAdkimTypes).forEach(([value, label], index) => {
                const checkedHtml = currentDmarcRecordAdkim === value ? `checked` : ``;
                modalHtml += `<div class="form-check form-check-inline">
                                        <input form="dmarc_form" class="form-check-input" type="radio" name="adkim" id="adkim_${index}" value='${e(value)}' ${checkedHtml}>
                                        <label class="form-check-label" for="adkim_${index}">${e(label)}</label>
                                      </div>`;
            });
            modalHtml += `
                                </div>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                    <div class="form-label">${_t('Alignment mode for the SPF protocol (aspf tag)')}</div>
            `;
            Object.entries(allowedDmarcRecordAspfTypes).forEach(([value, label], index) => {
                const checkedHtml = currentDmarcRecordAspf === value ? `checked` : ``;
                modalHtml += `<div class="form-check form-check-inline">
                                        <input form="dmarc_form" class="form-check-input" type="radio" name="aspf" id="aspf_${index}" value='${e(value)}' ${checkedHtml}>
                                        <label class="form-check-label" for="aspf_${index}">${e(label)}</label>
                                      </div>`;
            });
            modalHtml += `
                                </div>
                            </div>

                            <div class="d-flex">
                                <div class="flex-fill mx-2">
                                     <label for="rua_email" class="form-label">${_t('RUA report e-mail address (optional)')}</label>
                                     <input form="dmarc_form" class="form-control" type="email" name="rua_email" id="rua_email" value="${currentDmarcRecordRUA}">
                                </div>
                            </div>

                            <div class="d-flex my-3">
                                <div class="flex-fill mx-2">
                                     <label for="ruf_email" class="form-label">${_t('RUF report e-mail address (optional)')}</label>
                                     <input form="dmarc_form" class="form-control" type="email" name="ruf_email" id="ruf_email" value="${currentDmarcRecordRUF}">
                                </div>
                            </div>

                          <div class="modal-footer">
                            <input type="submit" id="dmarc_submit" form="content-edit-form" class="btn btn-primary" value="${_t('Save')}">
                          </div>
                        </div>
                      </div>
                    </div>
                   </div>`;
            html += `<input type="hidden" name="content" class="form-control" value="${(values.content ? e(values.content) : '')}" id="content" />`;
        } else if (values.content?.includes('v=spf1')) {
            //remove first (v=spf1) and last (~all) item

            const qualifier = values.content.trim().includes('-all') ? '-' : '~';

            //get spf qualifiers keys
            const spfRecordQualifierKeys = Object.keys(spfQualifiers);

            const existingSpfRecordItems = values.content.trim()
                .split(' ')
                .slice(1, -1)
                .map(function(item)  {
                    const type = item.split(':')[0] ?? '';
                    const content = item.split(':')[1] ?? '';
                    const qualifier = type.charAt(0) ? (spfRecordQualifierKeys.includes(type.charAt(0)) ? type.charAt(0) : '') : '';

                    return {
                        'qualifier': qualifier,
                        'type': qualifier ? type.substring(1) : type,
                        'content': content
                    }
                });

            modalHtml = `<div id="spfModal" class="modal" tabindex="-1">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">${_t('SPF record editor')}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="${_t('Close')}"></button>
                          </div>
                          <div class="modal-body">

                           <div class="mt-3 mb-3">
                                 <h5>${_t('Raw DNS record value')}:</h5>
                                 <code class="text-wrap ms-2" id="raw_spf_value">${e(values.content)}</code>
                            </div>

                            <div class="row">
                                <h5>${_t('Add new SPF record item')}:</h5>
                            </div>
                            <div class="mx-2 my-3">
                                <div class="form-label">${_t('SPF record qualifier')}</div>`;
                                Object.entries(spfQualifiers).forEach(([name, label], index) => {
                                    const checkedHtml = index === 0 ? `checked` : ``;
                                    modalHtml += `<div class="form-check form-check-inline">
                                        <input form="spf_form" class="form-check-input" type="radio" name="spf_qualifier" id="spf_qualifier_${index}" value='${e(name)}' ${checkedHtml}>
                                        <label class="form-check-label" for="spf_qualifier_${index}">${e(name)} ${e(label)}</label>
                                      </div>`;
                                });
                                modalHtml += `
                            </div>
                            <div class="mx-2 my-3">
                                <div class="form-label">${_t('SPF record type')}</div>`;
                                allowedSPFRecordTypes.forEach((item, index) => {
                                    const checkedHtml = index === 0 ? `checked` : ``;
                                    modalHtml += `<div class="form-check form-check-inline">
                                        <input form="spf_form" class="form-check-input" type="radio" name="spf_type" id="spf_type_${index}" value='${e(item)}' ${checkedHtml}>
                                        <label class="form-check-label" for="spf_type_${index}">${e(item)}</label>
                                      </div>`;
                                });
                                modalHtml += `
                            </div>
                            <div class="d-flex mt-2">
                                <div class="flex-fill mx-2">
                                    <label for="spf_content" class="form-label">${_t('SPF record value')}</label>
                                    <input form="spf_form" type="text" name="spf_content" class="form-control" value='' id="spf_content" placeholder="${_t('SPF record value')}" />
                                </div>
                                <div class="flex-fill mx-2 align-self-end">
                                    <button type="button" name="spf_add" class="form-control" id="spf_add_btn">${_t('Add')}</button>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <h5>${_t('Fallback action')}:</h5>

                                <div class="d-flex ms-4 my-3">
                                    <div class="form-check p-2">
                                      <input form="spf_form" class="form-check-input" type="radio" name="fallback_qualifier" id="fallbackQualifierSoftfail" value="~" ${qualifier === '~' ? ' checked' : ''}>
                                      <label class="form-check-label" for="fallbackQualifierSoftfail">
                                         ${_t('Soft fail (~all, default value)')}
                                      </label>
                                    </div>
                                    <div class="form-check ms-5 p-2">
                                      <input form="spf_form" class="form-check-input" type="radio" name="fallback_qualifier" id="fallbackQualifierHardfail" value="-" ${qualifier === '-' ? ' checked' : ''}>
                                      <label class="form-check-label" for="fallbackQualifierHardfail">
                                        ${_t('Hard fail (-all)')}
                                      </label>
                                    </div>
                                </div>

                            </div>
                            <div class="row mt-3">
                                <h5>${_t('SPF records')}:</h5>
                                <ol class="ms-4" id="spf_list">`
                                    existingSpfRecordItems.forEach((item) => {
                                    modalHtml += `
                                        <li class="my-2" data-type="${e(item.type)}" data-content="${e(item.content)}">
                                            ${e(item.qualifier)}${e(item.type)}:${e(item.content)}
                                            ${item.type === 'include' && item.content === '_spf.inbox.eu' ? `<span class="text-danger">(${_t('required')})</span>` : `<button type="button" class="btn btn-danger ms-2 spf_item_delete" style="margin-top:-5px">${_t('Delete')}</button>`}
                                        </li>`;
                                    });
                                    modalHtml += `
                                </ol>
                            </div>
                            <div class="mt-3">
                               <h5>${_t('Allowed values for each SPF type')}:</h5>
                                <p class="text-wrap ms-2">
                                * <b>ip4</b> ${_t('must contain IPv4 address with optional CIDR prefix.')} ${_t('Example')}: <code>127.0.0.1</code> ${_t('or')} <code>127.0.0.1/24</code><br>
                                * <b>ip6</b> ${_t('must contain IPv6 address with optional CIDR prefix.')} ${_t('Example')}: <code>::1</code> ${_t('or')} <code>::1/128</code><br>
                                * <b>include, a, mx, ptr</b> ${_t('must be valid domain name.')} ${_t('Example')}: <code>example.com</code> ${_t('or')} <code>mydomain.net</code><br>
                                * <b>a, mx</b> ${_t('may also contain CIDR prefix, example.')} ${_t('Example')}: <code>example.com/16</code><br>
                                </p>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <input type="submit" id="spf_submit" form="content-edit-form" class="btn btn-primary" value="${_t('Save')}">
                          </div>
                        </div>
                      </div>
                    </div>`;
            html += `<input type="hidden" name="content" class="form-control" value="${(values.content ? e(values.content) : '')}" id="content" />`;
        } else {
            html += `             <input type="text" name="content" class="form-control" value='${(values.content ? e(values.content) : '')}' id="content" placeholder="${_t('Content')}" />`;
        }

        if (modalHtml) {
            document.body.insertAdjacentHTML('beforeend', modalHtml);
        }

        html += `
                    </div>
                 </div>
                 `;
        html += `
                 <div class="content-column content-button-column">
                 `;
                    if (!values.id || !values.content.startsWith('v=spf1')) {
                        html += `<button class="btn btn-primary btn-block" id="saveDns">
                                   <i class="fa fa-check" aria-hidden="true"></i>
                                 </button>`;
                    }
        html += `
                 </div>

                 <div class="content-column content-column-narrow content-button-column">`;
        //todo change to global allowToDelete: bool
        if (values.id && !values.content.startsWith('v=spf1')) {
            html += `       <button type="button" class="btn btn-secondary btn-block" id="deleteDns" data-bs-toggle="modal" data-bs-target="#dnsDeleteModal" data-action="${(values.deleteUrl)}">`
            + '                 <i class="fa fa-trash" aria-hidden="true"></i>'
            + '             </button>';
        }
        html += '       </div>'
        + '       </div>'
        + '       </form>'

        return html;
    };

    function setDmarcContentInputFromDmarcInput() {
        const dmarcContentInput = qs('#content');
        const policyType = checkedValue('p');
        let dmarcContent = `v=DMARC1; p=${policyType}`;
        const sp = checkedValue('sp');
        if (sp) {
            dmarcContent += `; sp=${sp}`;
        }
        const np = checkedValue('np');
        if (np) {
            dmarcContent += `; np=${np}`;
        }
        const adkim = checkedValue('adkim');
        if (adkim) {
            dmarcContent += `; adkim=${adkim}`;
        }
        const aspf = checkedValue('aspf');
        if (aspf) {
            dmarcContent += `; aspf=${aspf}`;
        }
        const ruaEmail = qs('#rua_email').value;
        if (ruaEmail) {
            dmarcContent += `; rua=mailto:${ruaEmail}`;
        }
        const rufEmail = qs('#ruf_email').value;
        if (rufEmail) {
            dmarcContent += `; ruf=mailto:${rufEmail}`;
        }
        dmarcContent += ';';
        dmarcContentInput.value = dmarcContent;
        qs('#raw_dmarc_value').textContent = dmarcContent;
    }
    document.addEventListener('change', function (event) {
        const el = event.target;
        if (el.getAttribute('form') !== 'dmarc_form') return;

        setDmarcContentInputFromDmarcInput();
    });

    function setSpfContentInputFromOrderedSpfList() {
        const spfList = qs('#spf_list');
        const spfContentInput = qs('#content');
        const spfListItems = spfList.querySelectorAll('li');
        let spfContent = 'v=spf1 ';
        spfListItems.forEach((item) => {
            const qualifier = typeof item.dataset.qualifier === 'undefined' ? '' : item.dataset.qualifier;
            spfContent += `${qualifier}${item.dataset.type}:${item.dataset.content} `;
        });

        spfContent += qs('input[name="fallback_qualifier"]:checked').value + 'all';
        spfContentInput.value = spfContent;
        qs('#raw_spf_value').textContent = spfContent;
    }

    document.addEventListener('change', function (event) {
        const el = event.target;
        // if (el.getAttribute('name') !== 'fallback_qualifier') return;
        if (el.getAttribute('form') !== 'spf_form') return;

        setSpfContentInputFromOrderedSpfList();
    });

    document.addEventListener('click', function (event) {
        const el = event.target;
        if (!el.matches('#spf_add_btn')) return;
        event.preventDefault();

        const spfType = checkedValue('spf_type');
        const spfContentEl = qs('#spf_content');
        const spfContent = spfContentEl.value;
        const spfQualifier = checkedValue('spf_qualifier');

        //basic frontend validation
        if (!spfContent) {
            alert(_t('SPF record value is required'));
            return;
        }

        if (spfQualifier && spfQualifiers[spfQualifier] === undefined) {
            alert(_t('SPF record qualifier is not valid'));
            return;
        }

        if (spfType === 'ip4') {
            const ipv4_regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/(3[0-2]|[1-2]?\d))?$/;
            if (ipv4_regex.test(spfContent) === false) {
                alert(_t('SPF record value is not valid IPv4 address'));
                return;
            }
        }
        if (spfType === 'ip6') {
            const ipv6_regex = /^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$/gm;
            if (ipv6_regex.test(spfContent) === false) {
                alert(_t('SPF record value is not valid IPv6 address'));
                return;
            }
        }
        if (['include', 'a', 'mx', 'ptr'].includes(spfType)) {
            let domainTocheck = spfContent;
            if (!spfContent) {
                return; //value not required
            }


            //a and mx allow also CIDR prefixes mx:offsite.domain.com/24
            if (['a', 'mx'].includes(spfType)) {
                //todo naming: it is actually CIDR suffix
                let prefix = null;
                if (spfContent.includes('/')) {
                    domainTocheck = spfContent.split('/', 2)[0];
                    prefix = spfContent.substring(spfContent.indexOf('/') + 1);
                    if (!(prefix === '0' || (prefix >= 1 &&prefix <= 32))) {
                        alert(_t('SPF record value does not have valid prefix'));
                        return;
                    }
                }
            }

            const domainRegex = /[a-z0-9]+(?:[\-.][a-z0-9]+)*\.[a-z]{2,6}/;
            if (domainRegex.test(domainTocheck) === false) {
                alert(_t('SPF record value is not valid domain name'));
                return;
            }
        }

        const spfListItem = document.createElement('li');
        spfListItem.dataset.qualifier = spfQualifier
        spfListItem.dataset.type = spfType
        spfListItem.dataset.content = spfContent;
        const spfListItemName = document.createElement('span');
        spfListItemName.textContent = `${spfQualifier}${spfType}:${spfContent}`;
        spfListItem.appendChild(spfListItemName);

        const spfListItemBtn = document.createElement('button');
        spfListItemBtn.type = 'button';
        spfListItemBtn.setAttribute('class', 'btn btn-danger ms-2 spf_item_delete');
        spfListItemBtn.setAttribute('style', 'margin-top:-5px');
        spfListItemBtn.textContent = _t('Delete');
        spfListItem.appendChild(spfListItemBtn);

        qs('#spf_list').appendChild(spfListItem);

        spfContentEl.value = '';

        setSpfContentInputFromOrderedSpfList();
    }, false);

    document.addEventListener('click', function (event) {
        const el = event.target;
        if (!el.matches('.spf_item_delete')) return;
        event.preventDefault();
        el.parentNode.remove();
        setSpfContentInputFromOrderedSpfList();
    }, false);

    // Closes the open inline edit form and its record editor modal (a top-level element, appended
    // to <body> by editableForm — see the comment above modalHtml) and puts the original row back.
    const removeEditForm = () => {
        if (isRemovingEditForm) {
            return;
        }

        const $openEditForm = $userDnsTable.querySelector('.content-edit-form');
        const $openModal = qs('#spfModal, #dmarcModal');
        if (!$openEditForm && !$openModal) {
            return;
        }

        // Hiding a modal fires hidden.bs.modal, which calls this function again.
        isRemovingEditForm = true;

        if ($openModal) {
            const modal = Modal.getInstance($openModal);
            if (modal) {
                // Hide first so bootstrap restores backdrop and body state, only then drop the instance.
                modal.hide();
                modal.dispose();
            }
            $openModal.remove();
        }

        // Bootstrap's own backdrop cleanup can lag disposing the instance; belt and suspenders.
        document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');

        if ($editableRow && $openEditForm) {
            $openEditForm.before($editableRow);
            $editableRow = '';
        }

        if ($openEditForm) {
            $openEditForm.remove();
        }
        isRemovingEditForm = false;
    };

    const openRecordEditorModal = (selector) => {
        const $modalEl = qs(selector);
        if (!$modalEl) {
            return;
        }

        // Closing the editor modal cancels editing. Listen for hidden (not hide) so that bootstrap is
        // done with the modal before its element is removed from the DOM.
        $modalEl.addEventListener('hidden.bs.modal', removeEditForm, { once: true });

        Modal.getOrCreateInstance($modalEl).show();
    };

    document.addEventListener('click', function (event) {
        const el = event.target;
        if (!el.matches('#addNewDnsRecord') && !el.parentNode.matches('#addNewDnsRecord') ) return;
        const btn = el.matches('#addNewDnsRecord') ? el : el.parentNode;
        const formValues = JSON.parse(btn.dataset.values ?? '{}');

        removeEditForm();

        qs('#userDnsTable').innerHTML = qs('#userDnsTable').innerHTML + editableForm(formValues);
        // Append visual style from forms.js
        qs('.form-select').dispatchEvent(new Event('change'));

        qs('#name').focus();
    }, false);

    document.addEventListener('click', function (event) {
        const el = event.target;
        if (!el.matches('.content-edit-icon') && !el.parentNode.matches('.content-edit-icon')) return;
        const iconEl = el.matches('.content-edit-icon') ? el : el.parentNode;

        if (!iconEl.hasChildNodes()) {
            return;
        }

        // The times icon of the open form only cancels editing, it never opens another form.
        const isCancelIcon = iconEl.closest('.content-edit-form') !== null;

        removeEditForm();

        if (isCancelIcon) {
            return;
        }

        $editableRow = iconEl.closest('.content-row');
        $editableRow.insertAdjacentHTML('beforebegin', editableForm(JSON.parse($editableRow?.dataset?.values ?? '{}')));

        const elValues = JSON.parse($editableRow.dataset.values ?? '{}');

        // Remove by new instance;
        $editableRow.remove();

        //save button is in modal now and delete option is disabled
        if (elValues.content?.startsWith('v=spf1')) {
            openRecordEditorModal('#spfModal');
            return;
        }

        if (elValues.content?.startsWith('v=DMARC')) {
            openRecordEditorModal('#dmarcModal');
            return;
        }

        qs('#name').focus();
    });


    $dnsDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = event.relatedTarget;
        let action = button.dataset.action;

        $dnsDeleteModal.querySelector('#dnsDelete').setAttribute('action', action);
    });
};

const initialize = () => {
    dnsRecords();
};

export default initialize;
